import React from 'react'
import { Link } from 'react-router-dom'
import './RouterButton.scss'

function RouterButton(props) {
    return (
        <Link to={props.to} className='router-button'>
            {props.children}
        </Link>
    )
}

export default RouterButton